import React from "react";
import { isToday, isYesterday } from "date-fns";
import { ISocialChatMessage } from "store/chat/chat.state";

interface Props {
    messageTimestamp: number;
    messages: ISocialChatMessage[]
    className?: string;
}

const MessageDateGrouped: React.FC<Props> = ({ messageTimestamp, messages, className }) => {
    if (!messageTimestamp) return null;
    const currentMessageDate = new Date(messageTimestamp).toUTCString().slice(0, -12);
    const messagesOnSameDate = messages.reduce<ISocialChatMessage[]>(
        (results, msg) => {
            const msgDate: string = new Date(msg.AbsoluteTime).toUTCString().slice(0, -12);
            if (currentMessageDate === msgDate) {
                results.push(msg);
            }
            return results;
        },
        []
    );
    const earliestMessageTimestamp = Math.min(
      ...messagesOnSameDate.map((m) => new Date(m.AbsoluteTime).getTime())
    );
    const isFirstMessageForDate = messageTimestamp === earliestMessageTimestamp;

    return (
        <div className={className}>
            {isFirstMessageForDate ? (
                <p className="message-date xsm-mar">
                    {isToday(messageTimestamp)
                        ? 'Today'
                        : isYesterday(messageTimestamp)
                        ? 'Yesterday'
                        : currentMessageDate}
                </p>
            ) : null}
        </div>
    );
};

export default MessageDateGrouped;